import { io } from "socket.io-client";

let baseSocketUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_SOCKET_URL : process.env.REACT_APP_PROD_SOCKET_URL;

export const socket = io(baseSocketUrl, {
    transports: ['websocket'],
    timeout: 20000,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    autoConnect: false
});